import { render, staticRenderFns } from "./birimsecimi.vue?vue&type=template&id=1dbe62f4&"
import script from "./birimsecimi.vue?vue&type=script&lang=js&"
export * from "./birimsecimi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports